import React from 'react'
import { PersonBlock } from '@fs/zion-ui'
import { PersonLink } from '../app/Links'

const CommonPerson = ({ details, gender, name, personId }) => {
  return (
    <PersonBlock
      size="sm"
      avatarProps={{
        sex: `${gender.toLowerCase()}`,
      }}
      name={personId ? <PersonLink personId={personId} personName={name} showId /> : `${name}`}
      details={details}
    />
  )
}

export default CommonPerson
